import { defineComponent as _defineComponent } from 'vue'
import { useTranslations } from '@/core/translate.mixin';
import TrackingService from '@/core/tracking.service';
import BasketSummaryLines from '@/ui/views/checkout/BasketSummaryLines.vue';
import BasketSummaryTotal from '@/ui/views/checkout/BasketSummaryTotal.vue';
import BasketViewModel = Vertica.LouisPoulsen.Application.Commerce.ViewModels.Consumer.BasketViewModel;
import { onMounted, ref } from 'vue';
import { useValidator } from '@/core/app.service';
import { useRouter } from 'vue-router/composables';
import { useNewsletter } from '@/store/newsletter.composable';
import ServerContextService from '@/core/server-context.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketSummaryB2C',
  props: {
    basket: null,
    checkoutUrl: null
  },
  setup(__props: any) {

const props = __props as {
    basket: BasketViewModel,
    checkoutUrl: string
}


const { privacyPolicyStatementHtml, newsletterFlagText, profilingFlagText, submitMarketingEmailPermission } = useNewsletter();

const acceptMarketingForm = ref<AcceptMarketingEmailsWebRequest>({
    email: '',
    firstName: '',
    lastName: '',
    newsletterFlagAccepted: false,
    profilingFlagAccepted: false
});

const $validator = useValidator();

function validateAndProcessInformation() {
    $validator
        .validateAll()
        .then(processInformation)
        .catch(x => { console.log('catch' + x); });
}

function isAllowedToSendAbandonBasketMail() {
    //  Only country that does not send abandon basket right now is JP. So exclude JP here
    const locale = ServerContextService.languages.find(l => l.isSelected).code;
    const isJapan = locale.toLowerCase() === 'ja-JP'.toLowerCase();
    return !isJapan;
}

const router = useRouter();

async function processInformation(isValid: boolean) : Promise<void> {
    if (!isValid) {
        scrollInvalidElementIntoView();
        return;
    }
    try {
        if (acceptMarketingForm.value.newsletterFlagAccepted) {
            await submitMarketingEmailPermission(acceptMarketingForm.value);
            TrackingService.event('Newsletter in checkout', 'page1', 'subscribe');
        }
        router.push(props.checkoutUrl);
    } catch (err) {}
}

function scrollInvalidElementIntoView() {
    const firstInvalidElement = document.querySelector(".is-danger");
    if (firstInvalidElement) {
        firstInvalidElement.scrollIntoView({ behavior: "smooth" });
        (firstInvalidElement as HTMLElement).focus();
    }
}

onMounted(() => {
    const dictionary = {
        custom: {
            email: {
                required: t('Pages.Basket.EmailAddressForMarketingRequiredErrorMessage'),
                email: t('Pages.Basket.EmailAddressForMarketingInvalidErrorMessage')
            }
        }
    };
    $validator.localize('en', dictionary);

    if (!props.basket.hasSubmittedMarketingEmailPermission) {
        TrackingService.event('Newsletter in checkout', 'page1', 'CheckoutNudge');
    }
});

const { t } = useTranslations();

return { __sfc: true,props, privacyPolicyStatementHtml, newsletterFlagText, profilingFlagText, submitMarketingEmailPermission, acceptMarketingForm, $validator, validateAndProcessInformation, isAllowedToSendAbandonBasketMail, router, processInformation, scrollInvalidElementIntoView, t, BasketSummaryLines, BasketSummaryTotal }
}

})